import useManyRemoteM1 from '@aims/shared/shared/use-many-remote-m1';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import CSPage from '../../components/CSPage';
import CSPageHeader from '../../components/CSPageHeader';
import settings from '../../settings';
import { generateUuid } from '../../shared/utils';
import ListLoanAgreements from './ListLoanAgreements';
import {
  allLoanAgreementTemplatesQuery,
  extractLoanAgreements,
} from './constants';

function ListLoanAgreementTemplatesPage() {
  const createId = useMemo(() => {
    return generateUuid();
  }, []);

  const [sortedBy, setSortedBy] = useState('updatedAt');
  const [sortOrder, setSortOrder] = useState('DESC');
  const filters = useRef({
    isTemplate: true,
  });
  const sortBy = useRef([
    { key: sortedBy, order: sortOrder },
    { key: '_score', order: 'DESC' },
  ]);

  const {
    error,
    loading,
    data: loanAgreements,
    search: loanAgreementsSearch,
    hasNextPage,
    next,
    refetch,
    reset,
  } = useManyRemoteM1({
    query: allLoanAgreementTemplatesQuery,
    extract: extractLoanAgreements,
    first: settings.querySize,
    filters: filters.current,
    sortBy: sortBy.current,
    fetchPolicy: 'network-only',
    queryId: 'listLoanAgreementTemplatesPage',
  });

  const onSortedByChange = useCallback(
    (value) => {
      sortBy.current = [
        {
          key: value,
          order: sortOrder,
        },
      ];
      refetch();
      setSortedBy(value);
    },
    [sortOrder, refetch],
  );

  const onSortOrderChange = useCallback(
    (value) => {
      sortBy.current = [
        {
          key: sortedBy,
          order: value,
        },
        { key: '_score', order: 'DESC' },
      ];
      refetch();
      setSortOrder(value);
    },
    [sortedBy, refetch],
  );

  const onFiltersChanged = useCallback(
    (_changed) => {
      const { search, ...changed } = _changed;
      if (search != undefined) {
        sortBy.current = [
          { key: '_score', order: 'DESC' },
          {
            key: sortedBy,
            order: sortOrder,
          },
        ];
        loanAgreementsSearch(search);
      } else {
        filters.current = {
          isTemplate: true,
          ...filters.current,
          ...Object.entries(changed).reduce((prev, [k, v]) => {
            prev[k] = v ? v : undefined;
            return prev;
          }, {}),
        };
        refetch();
      }
    },
    [loanAgreementsSearch, refetch, sortedBy, sortOrder],
  );

  return (
    <>
      <CSPage
        containerStyle={{ maxWidth: 'unset' }}
        title="Loan Agreement Templates"
      >
        <CSPageHeader
          title="Loan Agreement Templates"
          topActions={[
            <Link
              key="add"
              to={{
                pathname: `/loan-agreement-template/view/${createId}`,
                state: {
                  mode: 'create',
                },
              }}
            >
              <Button type="link" icon={<PlusCircleOutlined />} size="large">
                Add a Loan Agreement Template
              </Button>
            </Link>,
          ]}
        />
        <ListLoanAgreements
          loading={loading}
          error={error}
          loanAgreements={loanAgreements}
          next={next}
          hasNextPage={hasNextPage}
          refetch={refetch}
          onFiltersChanged={onFiltersChanged}
          onSortedByChange={onSortedByChange}
          onSortOrderChange={onSortOrderChange}
        />
      </CSPage>
      <style jsx>{``}</style>
    </>
  );
}

export default ListLoanAgreementTemplatesPage;
